import banner from './banner';
import aboutUs from './about-us';



function getComponent(){
    let urlHash = window.location.hash;
    let component = '';
    switch(urlHash){
        case "#about-us":
            console.log("aboutus");
            component = aboutUs;
            break;
        default:
            component = banner;
    }
return component
}

let component = getComponent();
console.log("comp",component);

window.addEventListener("hashchange", function(){
    console.log("listening and changing");
    
    let main = document.getElementsByTagName('Main')[0];
    let component = getComponent();
    console.log("comp", component);
    
    main.innerHTML = component;
});

export default `
    ${component}
`